import {
  GET_INT_CUSTOMER_BY_PO_REQUEST,
  GET_INT_CUSTOMER_BY_PO_SUCCESS,
  GET_INT_CUSTOMER_BY_PO_ERROR
} from "../actions/types";

export const INTCustomerByPO = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_INT_CUSTOMER_BY_PO_REQUEST:
      return {
        loading: true,
      };
    case GET_INT_CUSTOMER_BY_PO_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_INT_CUSTOMER_BY_PO_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};
